<template lang="pug">
.v-field-question.field-question(v-if="field")
	button.field-question__btn(v-for="option in field.options" type="button" @click="localValue = option.value; handlerInput();" :class="option.className")
		img.field-question__btn-icon(v-if="option.icon" :src="option.icon")
		| {{option.text}}
</template>

<script>


export default {
	props: {
		field: {
			type: Object,
			default: null,
			required: true
		},

		modelValue: {
			type: [Object, String, Number, Boolean, Symbol, Date],
			default: null
		}
	},

	emits: [
		'update:model-value'
	],

	data() {
		return {
			localValue: null,
		}
	},

	watch: {
		modelValue() {
			this.updateLocalValue();
		}
	},

	created() {
		this.updateLocalValue();
	},

	methods: {
		updateLocalValue() {
			this.localValue = this.modelValue;
		},

		handlerInput() {
			this.$emit('update:model-value', this.localValue, this.field);
		}
	}
}

</script>